export const storeNameBackOfficeAuth = 'authBO';

export function useAuthBackOffice(): string | null | undefined {
  const strAuth = sessionStorage.getItem(storeNameBackOfficeAuth);
  if (!strAuth) return null;

  const auth: { email: string } = JSON.parse(strAuth);
  return auth.email;
}
